export default __webpack_public_path__ + "static/media/medication.b4b85de9.svg";